import { Phase_BugGroupsGeneratedEntity } from "./generated/Phase_BugGroupsGeneratedEntity";

export abstract class Phase_BugGroupsEntity extends Phase_BugGroupsGeneratedEntity {
    // Comment to preserve new line
}
